<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { visibleNavZones } from "./model/navigation";
import NavItem from "./NavItem.vue";

/**
 * Бічна навігація з частотним поділом (IA D2). Зони фільтруються через
 * `visibleNavZones(canManageSalon)` — єдиний seam для role-gating (IA D3).
 * Зараз owner-режим: усі зони видимі (RBAC — feature-021).
 */
const props = withDefaults(defineProps<{ canManageSalon?: boolean }>(), {
  canManageSalon: true,
});

const { t } = useI18n();
const zones = computed(() => visibleNavZones(props.canManageSalon));
</script>

<template>
  <nav
    class="flex flex-col gap-6 p-3"
    :aria-label="t('layout.aria.sections')"
  >
    <div
      v-for="zone in zones"
      :key="zone.id"
      :data-testid="`nav-zone-${zone.id}`"
      class="flex flex-col gap-1"
    >
      <p
        class="px-3 pb-1 text-xs font-medium tracking-wide text-muted-foreground/80 uppercase"
      >
        {{ t(zone.titleKey) }}
      </p>
      <NavItem
        v-for="item in zone.items"
        :key="item.name"
        :to="item.to"
        :label="t(item.labelKey)"
        :icon="item.icon"
        :exact="item.exact"
      />
    </div>
  </nav>
</template>
